import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { INVOICE_PREVIEW_APPEARANCE_PANEL_WIDTH } from '@features/invoicingSettings/constants/invoicePreviewAppearancePanelWidth'

export const InvoicePreviewAppearanceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: ${INVOICE_PREVIEW_APPEARANCE_PANEL_WIDTH}px;
  padding: ${Spacing.S16} ${Spacing.S24};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
  position: relative;
  overflow-y: auto;
`
